import GenericScreen from "../GenericScreen";
import CheckIcon from "@mui/icons-material/Check";
import { Box } from "@mui/material";

import imgScreen from "../../../../../../Assets/StoryRunner/BRD11.png";
import ticket from "../../../../../../Assets/StoryRunner/Group_1261152859.png";

import connectWithDispatch from "../../../../../../Hooks/connectWithDispatch";

import * as appActions from "../../../../../../Actions/appActions";

interface ScreenProps {
  transition: number;
  screen: number;
  setStory: (value: Partial<StoryType>) => void;
  t: (key: string) => ReactNode;
}

const Screen = (props: ScreenProps) => {
  const { transition, setStory, screen } = props;

  const handleNextScreen = () => {
    setTimeout(() => setStory({ screen: screen + 1 }), 1000);
  };

  return (
    <>
      <GenericScreen
        showComponent={transition >= 4}
        showContent={true}
        icon={<CheckIcon sx={styles.icon} />}
        title={"Looks like a match!"}
        text={"Get this to the destination as soon as possible."}
        panelRight={<PhoneScreenOne handleNextScreen={handleNextScreen} />}
        srcImg={ticket}
      />
    </>
  );
};

const styles = {
  icon: {
    fontSize: "5.2083em",
    color: "#00B28F",
  },
  imgScreen: {
    objectFit: "contain" as "contain",
    width: "100%",
    borderRadius: "26px",
  },
};

interface PhoneScreenOneProps {
  handleNextScreen: () => void;
}

const PhoneScreenOne = (props: PhoneScreenOneProps) => {
  return (
    <Box sx={{ position: "relative" }}>
      <Box
        onClick={props.handleNextScreen}
        sx={{ cursor: "pointer", position: "absolute", bottom: "22vh", width: "31.5vh", height: "4vh", left: "5vh" }}
      ></Box>

      <img style={styles.imgScreen} src={imgScreen} alt="" />
    </Box>
  );
};

const mapStateToProps = (state: StateType) => {
  return {
    transition: state.appReducer.story.transition,
    screen: state.appReducer.story.screen,
  };
};

const mapDispatchToProps: MapDispatchToProps = {
  setStory: appActions.setStory,
};

export default connectWithDispatch(Screen, mapStateToProps, mapDispatchToProps);
